<template>
  <div class="plan-player-component"
       @click.stop="handleClick"
  >
    <player-style :playing="playing"
                  :loading="playing && loading"
                  :duration="duration"
                  :type="type"
    />
  </div>
</template>

<script>
  import { mapGetters } from 'vuex';
  import PlayerPlaylistStorageMixin from '@/mixins/player/playerPlaylistStorage';
  import PlayerStyle from '@/components/TrainingPlayer/PlayerStyle';
  import { upperCaseFirst } from '@/utils';
  import validator from '@/utils/validator';

  export default {
    name: 'TrainingAudioPlayer',
    mixins: [PlayerPlaylistStorageMixin],
    components: {
      PlayerStyle,
    },
    data() {
      return {
        disabled: false,
        isSetList: false,
      };
    },
    props: {
      current: {
        type: Number,
        required: true,
      },
      source: {
        validator(val) {
          return validator.isObject(val);
        },
        required: true,
      },
      duration: {
        type: Number,
        required: true,
      },
      type: {
        type: String,
        required: true,
        validator(val) {
          return ['task', 'work'].includes(val);
        },
      },
    },
    computed: {
      ...mapGetters([
        'player',
      ]),
      playing() {
        return this.player.playingId === this.current;
      },
      loading() {
        const { player } = this;
        const { loadingStatus } = player;
        return loadingStatus === 'loading';
      },
      eventLogType() {
        const eventLogTypeMap = {
          task: 'audio',
          work: 'voice',
        };
        return `plan${upperCaseFirst(eventLogTypeMap[this.type])}`;
      },
    },
    watch: {
      source(val) {
        this.isSetList = !(val.mp3.length !== 0);
      },
    },
    methods: {
      validatorSrc() {
        if (this.source.mp3.length === 0) {
          this.$dialog.alert({
            message: '音频链接出错，请刷新页面',
            confirmButtonText: '好的',
            closeOnClickOverlay: false,
          });
          this.$emit('emptysrc');
          return false;
        }
        return true;
      },
      async handleClick() {
        if (this.disabled) return;

        this.disabled = true;
        const { player } = this;

        if (this.playing) {
          player.pause();
          this.disabled = false;
          return;
        }
        if (this.validatorSrc()) {
          if (!this.isSetList) {
            const { current: id, source, duration } = this;
            this.setGlobalPlayerInfo([{
              id,
              source,
              duration,
            }], true, false, this.eventLogType);
          }
          player.play();
        }

        this.disabled = false;
      },
    },
    created() {
      this.isSetList = false;
    },
  };
</script>
